import React from 'react';

const BarCode = () => {
    return (
        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0.85" y1="0.85" x2="0.85" y2="8.15" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" />
            <line x1="12.85" y1="0.85" x2="12.85" y2="8.15" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" />
            <line x1="6.85" y1="0.85" x2="6.85" y2="8.15" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" />
            <line x1="3.85" y1="0.85" x2="3.85" y2="7.15" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" />
            <line x1="9.85" y1="0.85" x2="9.85" y2="7.15" stroke="#00A7B5" stroke-width="1.7" stroke-linecap="round" />
        </svg>
    );
}

export default BarCode;
